
import './App.css';
import NavBar from './Components/Navbar';
//import MobileView from './Components/MobileView';
//import { GiHamburgerMenu } from 'react-icons/gi';
import './StudentDetails.css';
//import StudentDetails from './Components/studentdetails';
//import SalesTable from './Components/tableformat'
import LeftNavApp from './Components/LeftNavBar';
//import SideNavApp from './Components/SideNavBar';
import LoginForm from './Components/LogInForm';
import Dashboard from './Components/dashboard';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import StudentDetails from './Components/studentdetails';
import SalesTable from './Components/tableformat';
import StudentDetails1 from './Components/TestEntry';
import FeesEntry from './Components/FeesEntry';
import NewStudentList from './Components/newstudentlist';
import BusFeesEntry from './Components/BusFeesEntry';
import PendingFeesList from './Components/PendingFeesList';
import OverAllStudentList from './Components/OverAllStudentList';
import NaviTest from './Components/NavicatTest';
import StudentPromotionList from './Components/StudentPromotion';
import CollectionReport from './Components/Reports/CollectionReport';
import PendingStudentList from './Components/PendingStudent';
import Layout from './Components/Layout';
import SideNavApp1 from './Components/IconSideNavBar';
import { AuthProvider } from './Components/LogIn/AuthContext'; 
import { useAuth } from './Components/LogIn/AuthContext';
import PrivateRoute from './Components/PrivateRoute';
import FeesAddMaster from './Components/Fees/FeesMaster';
//import './PendingList.css';

// function App() {


//    const { user } = useAuth();

//   console.log("Logged in username:", user?.name); // ← you can use this

//   return (
// //     <div className="App">

// //  <SideNavApp/>
// //     </div>

//  <AuthProvider>
//       <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<LoginForm />} />
//         <Route path="/*" element={<SideNavApp1 />} />
//       </Routes>
//       </BrowserRouter>
//       </AuthProvider>
    
//   );
// } 



function AppRoutes() {
  const { user } = useAuth();

  console.log("Logged in user111:", user); // ✅ Safe to use here

  return (
    <Routes>
      <Route path="/" element={<LoginForm />} />
      {/* <Route path="/*" element={<SideNavApp1 user={user}/>} /> */}
      <Route 
  path="/*" 
  element={ user ? <SideNavApp1 user={user} /> : <LoginForm /> } 
/>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
